import { render, staticRenderFns } from "./SubmissionCompactStep.vue?vue&type=template&id=c9cc3ba2&scoped=true&"
import script from "./SubmissionCompactStep.vue?vue&type=script&lang=js&"
export * from "./SubmissionCompactStep.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionCompactStep.vue?vue&type=style&index=0&id=c9cc3ba2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cc3ba2",
  null
  
)

export default component.exports